import Horizon from "Horizon/Horizon"
import { StyledHorizon, StyledHorizonContainer, StyledHorizonTitle } from "Horizon/styled"

export { Horizon, StyledHorizon, StyledHorizonContainer, StyledHorizonTitle }
